module.exports = __webpack_public_path__ + "assets/img/NVIDIA-ba8b9f4e.png";